import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	const [input5, onChangeInput5] = useState('');
	const [input6, onChangeInput6] = useState('');
	const [input7, onChangeInput7] = useState('');
	const [input8, onChangeInput8] = useState('');
	const [input9, onChangeInput9] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 1477,
					alignSelf: "stretch",
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-start",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						display: "flex",
						alignItems: "flex-start",
						gap: 32,
					}}>
					<div 
						style={{
							flexShrink: 0,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 783,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/kxudhc1z_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									gap: 13,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"John Doe"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #F57E47, #F36421)",
										borderRadius: 3,
										paddingTop: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentor"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 1,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tig3dcxm_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"johndoe123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 22,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/b2q2qz3u_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Dashboard"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#FFFFFF",
										fontSize: 16,
										fontWeight: "bold",
										width: 80,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginLeft: 32,
									gap: 40,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/865ms624_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Mentees"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 4,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lz7zsg2x_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Requests"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4c5fb4ut_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Chats"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v30n7ngb_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Community"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m1t48y9g_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Notifications"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/na51bcgk_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Settings"}
									</span>
								</div>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 0,
								left: 229,
								width: 1211,
								display: "flex",
								alignItems: "center",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 38,
								paddingRight: 38,
							}}>
							<div 
								style={{
									flex: 1,
									display: "flex",
									alignItems: "center",
									background: "#F6F7F9",
									borderRadius: 8,
									paddingTop: 14,
									paddingBottom: 14,
									marginRight: 257,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m5k5dhw3_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										marginLeft: 20,
										marginRight: 12,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"For quick access to mentees or posts"}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										flex: 1,
										alignSelf: "stretch",
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									alignItems: "center",
									background: "#FEF0E9",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 20,
									paddingRight: 23,
									marginRight: 32,
									gap: 8,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sqlq38ev_expires_30_days.png"} 
									style={{
										width: 32,
										height: 32,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#F57E47",
										fontSize: 17,
										fontWeight: "bold",
									}} >
									{"Ask Giia"}
								</span>
							</div>
							<div 
								style={{
									width: 1,
									height: 58,
									background: "#E6E6E6",
									marginRight: 31,
								}}>
							</div>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o391m09t_expires_30_days.png"} 
								style={{
									width: 24,
									height: 24,
									marginRight: 24,
									objectFit: "fill",
								}}
							/>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ov9br8b6_expires_30_days.png"} 
								style={{
									width: 24,
									height: 24,
									objectFit: "fill",
								}}
							/>
						</div>
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							flexShrink: 0,
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							marginTop: 130,
							gap: 32,
						}}>
						<div 
							style={{
								display: "flex",
								alignItems: "flex-start",
							}}>
							<span 
								style={{
									color: "#010101",
									fontSize: 40,
									fontWeight: "bold",
									marginRight: 715,
								}} >
								{"Dashboard"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 18,
									marginTop: 20,
								}} >
								{"Welcome Back, John Doe!"}
							</span>
						</div>
						<div 
							style={{
								display: "flex",
								alignItems: "flex-start",
								gap: 33,
							}}>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 20,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 20,
										fontWeight: "bold",
										marginBottom: 20,
										marginLeft: 20,
									}} >
									{"Mentee Overview"}
								</span>
								<div 
									style={{
										width: 514,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 31,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 20,
										marginRight: 20,
										gap: 20,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#E7F1F8",
											borderRadius: 12,
											paddingTop: 24,
											paddingBottom: 24,
											gap: 27,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginLeft: 16,
												marginRight: 16,
											}}>
											<span 
												style={{
													color: "#1074BC",
													fontSize: 28,
													fontWeight: "bold",
													marginRight: 71,
												}} >
												{"8"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tad1uim9_expires_30_days.png"} 
												style={{
													width: 39,
													height: 23,
													objectFit: "fill",
												}}
											/>
										</div>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
												marginLeft: 16,
											}} >
											{"Total\nMentees"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FEF0E9",
											borderRadius: 12,
											paddingTop: 24,
											paddingBottom: 24,
											gap: 27,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginLeft: 16,
												marginRight: 16,
												gap: 44,
											}}>
											<span 
												style={{
													color: "#F57E47",
													fontSize: 28,
													fontWeight: "bold",
												}} >
												{"68%"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vjidr8mm_expires_30_days.png"} 
												style={{
													width: 24,
													height: 24,
													objectFit: "fill",
												}}
											/>
										</div>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
												marginLeft: 16,
											}} >
											{"Average\nProgress"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#E6F7FD",
											borderRadius: 12,
											paddingTop: 24,
											paddingBottom: 24,
											gap: 27,
										}}>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginLeft: 16,
												marginRight: 16,
											}}>
											<span 
												style={{
													color: "#00AEEF",
													fontSize: 28,
													fontWeight: "bold",
													marginRight: 69,
												}} >
												{"42"}
											</span>
											<img
												src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/bcph449v_expires_30_days.png"} 
												style={{
													width: 24,
													height: 24,
													objectFit: "fill",
												}}
											/>
										</div>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 14,
												fontWeight: "bold",
												marginLeft: 16,
											}} >
											{"Sessions\nCompleted"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 20,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginRight: 279,
										}} >
										{"Mentee Overview"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View all"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/m9sb7mgi_expires_30_days.png"} 
											style={{
												width: 9,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										width: 515,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 19,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/zast2fsm_expires_30_days.png"} 
										style={{
											width: 39,
											height: 39,
											marginRight: 12,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 69,
											gap: 6,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"John Doe"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Request on 7 April 2025"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 68,
											gap: 8,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Status"}
										</span>
										<span 
											style={{
												color: "#FF3737",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"High Priority"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 15,
											paddingRight: 15,
											gap: 8,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												paddingBottom: 1,
											}}>
											<span 
												style={{
													color: "#00AEEF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Review Request"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/5ugr10w6_expires_30_days.png"} 
											style={{
												borderRadius: 6,
												width: 10,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o6mq47pk_expires_30_days.png"} 
										style={{
											width: 39,
											height: 39,
											marginRight: 12,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 69,
											gap: 6,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Jenny Wilson"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Request on 7 April 2025"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 71,
											gap: 8,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Status"}
										</span>
										<span 
											style={{
												color: "#EEBD10",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Low Priority"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 15,
											paddingRight: 15,
											gap: 8,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												paddingBottom: 1,
											}}>
											<span 
												style={{
													color: "#00AEEF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Review Request"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pmyz4ggc_expires_30_days.png"} 
											style={{
												borderRadius: 6,
												width: 10,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hqiz3t2x_expires_30_days.png"} 
										style={{
											width: 39,
											height: 39,
											marginRight: 12,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 69,
											gap: 6,
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"Albert Flores"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Request on 7 April 2025"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											marginRight: 68,
											gap: 8,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Status"}
										</span>
										<span 
											style={{
												color: "#FF3737",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"High Priority"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											background: "#E6F7FD",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 15,
											paddingRight: 15,
											gap: 8,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												paddingBottom: 1,
											}}>
											<span 
												style={{
													color: "#00AEEF",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Review Request"}
											</span>
										</div>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mefr1ekn_expires_30_days.png"} 
											style={{
												borderRadius: 6,
												width: 10,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								display: "flex",
								alignItems: "flex-start",
								gap: 32,
							}}>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 20,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginRight: 166,
										}} >
										{"Impact Dashboard"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View Full Impact Report"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ti853wfl_expires_30_days.png"} 
											style={{
												width: 9,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										width: 514,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 23,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 17,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
											fontWeight: "bold",
											marginRight: 183,
										}} >
										{"Session Hours Over Time"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 5,
											border: `1px solid #E6E6E6`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 12,
											paddingRight: 10,
										}}>
										<input
											placeholder={"Last 6 months"}
											value={input3}
											onChange={(event)=>onChangeInput3(event.target.value)}
											style={{
												color: "#010101",
												fontSize: 14,
												fontWeight: "bold",
												width: 102,
												background: "none",
												border: "none",
											}}
										/>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/q941fbnb_expires_30_days.png"} 
											style={{
												borderRadius: 5,
												width: 11,
												height: 7,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginLeft: 24,
										marginRight: 24,
										position: "relative",
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											marginRight: 19,
											gap: 19,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"50h"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"40h"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"30h"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"20h"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"10h"}
										</span>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
											}} >
											{"0h"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
										}}>
										<div 
											style={{
												width: 465,
												height: 1,
												background: "#E6E6E6",
												marginBottom: 4,
											}}>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "flex-start",
											}}>
											<div 
												style={{
													width: 5,
													height: 119,
													background: "#53DB61",
													marginTop: 59,
													marginRight: 4,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 146,
													background: "#E35A5A",
													marginTop: 32,
													marginRight: 74,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 173,
													background: "#54DC61",
													marginTop: 6,
													marginBottom: 6,
													marginRight: 4,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 96,
													background: "#E45B5B",
													marginTop: 83,
													marginRight: 73,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 73,
													background: "#54DC61",
													marginTop: 106,
													marginRight: 4,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 143,
													background: "#E45B5B",
													marginTop: 36,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													alignSelf: "stretch",
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 178,
													background: "#54DC61",
													marginRight: 3,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 80,
													background: "#E45B5B",
													marginTop: 99,
													marginRight: 75,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 130,
													background: "#54DC61",
													marginTop: 49,
													marginRight: 3,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 59,
													background: "#E45B5B",
													marginTop: 120,
													marginRight: 75,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 146,
													background: "#54DC61",
													marginTop: 32,
													marginRight: 3,
												}}>
											</div>
											<div 
												style={{
													width: 5,
													height: 116,
													background: "#E45B5B",
													marginTop: 63,
												}}>
											</div>
										</div>
										<div 
											style={{
												width: 465,
												height: 1,
												background: "#E6E6E6",
											}}>
										</div>
									</div>
									<div 
										style={{
											position: "absolute",
											top: 45,
											right: 0,
											width: 465,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
									<div 
										style={{
											position: "absolute",
											top: 82,
											right: 0,
											width: 465,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
									<div 
										style={{
											position: "absolute",
											bottom: 80,
											right: 0,
											width: 465,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
									<div 
										style={{
											position: "absolute",
											bottom: 43,
											right: 0,
											width: 465,
											height: 1,
											background: "#E6E6E6",
										}}>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginBottom: 30,
										marginLeft: 68,
									}}>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
											marginRight: 64,
										}} >
										{"JAN"}
									</span>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
											marginRight: 61,
										}} >
										{"FEB"}
									</span>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
											marginRight: 62,
										}} >
										{"MAR"}
									</span>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
											fontWeight: "bold",
											marginRight: 62,
										}} >
										{"APR"}
									</span>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
											marginRight: 62,
										}} >
										{"MAY"}
									</span>
									<span 
										style={{
											color: "#818280",
											fontSize: 14,
										}} >
										{"JUN"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "linear-gradient(180deg, #F57E47, #F36421)",
										borderRadius: 8,
										paddingTop: 14,
										paddingBottom: 14,
										paddingLeft: 22,
										paddingRight: 22,
										marginLeft: 24,
										marginRight: 24,
										gap: 11,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/x16gbuno_expires_30_days.png"} 
										style={{
											borderRadius: 8,
											width: 21,
											height: 21,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"5 mentees completed their goals this month."}
										value={input4}
										onChange={(event)=>onChangeInput4(event.target.value)}
										style={{
											color: "#FFFFFF",
											fontSize: 17,
											fontWeight: "bold",
											width: 361,
											background: "none",
											border: "none",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									flexShrink: 0,
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									paddingTop: 20,
									paddingBottom: 20,
									boxShadow: "0px 1px 3px #00000003",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 20,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginRight: 206,
										}} >
										{"Community Activity Feed"}
									</span>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "center",
											gap: 8,
										}}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View all"}
										</span>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tvq3pf66_expires_30_days.png"} 
											style={{
												width: 9,
												height: 9,
												objectFit: "fill",
											}}
										/>
									</div>
								</div>
								<div 
									style={{
										width: 514,
										height: 1,
										background: "#E6E6E6",
										marginBottom: 23,
										marginLeft: 20,
										marginRight: 20,
									}}>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										padding: 16,
										marginBottom: 16,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/665czlqm_expires_30_days.png"} 
										style={{
											width: 59,
											height: 44,
											marginRight: 17,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"What are the best AI tools for startups?"}
										value={input5}
										onChange={(event)=>onChangeInput5(event.target.value)}
										style={{
											color: "#010101",
											fontSize: 15,
											fontWeight: "bold",
											width: 314,
											background: "none",
											border: "none",
											paddingTop: 4,
											paddingBottom: 4,
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/n2shznl6_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View Q&A"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										padding: 16,
										marginBottom: 16,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/57iqgm9j_expires_30_days.png"} 
										style={{
											width: 59,
											height: 44,
											marginRight: 17,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"What are the best AI tools for startups?"}
										value={input6}
										onChange={(event)=>onChangeInput6(event.target.value)}
										style={{
											color: "#010101",
											fontSize: 15,
											fontWeight: "bold",
											width: 314,
											background: "none",
											border: "none",
											paddingTop: 4,
											paddingBottom: 4,
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o2lzi2a8_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View Q&A"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										padding: 16,
										marginBottom: 16,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/o7f0agbu_expires_30_days.png"} 
										style={{
											width: 59,
											height: 44,
											marginRight: 17,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"What are the best AI tools for startups?"}
										value={input7}
										onChange={(event)=>onChangeInput7(event.target.value)}
										style={{
											color: "#010101",
											fontSize: 15,
											fontWeight: "bold",
											width: 314,
											background: "none",
											border: "none",
											paddingTop: 4,
											paddingBottom: 4,
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1cybvyic_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View Q&A"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FFFFFF",
										borderRadius: 12,
										border: `1px solid #E6E6E6`,
										padding: 16,
										marginLeft: 20,
										marginRight: 20,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8nvrfjw8_expires_30_days.png"} 
										style={{
											width: 59,
											height: 44,
											marginRight: 17,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"What are the best AI tools for startups?"}
										value={input8}
										onChange={(event)=>onChangeInput8(event.target.value)}
										style={{
											color: "#010101",
											fontSize: 15,
											fontWeight: "bold",
											width: 314,
											background: "none",
											border: "none",
											paddingTop: 4,
											paddingBottom: 4,
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											alignItems: "flex-start",
											paddingRight: 2,
											gap: 4,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/e1io9z55_expires_30_days.png"} 
											style={{
												width: 17,
												height: 17,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#00AEEF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"View Q&A"}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								borderRadius: 12,
								paddingTop: 20,
								paddingBottom: 33,
								boxShadow: "0px 1px 3px #00000003",
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 20,
										fontWeight: "bold",
										marginRight: 871,
									}} >
									{"Resource Library"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										gap: 8,
									}}>
									<span 
										style={{
											color: "#979797",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"View all"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/rxqp4tpt_expires_30_days.png"} 
										style={{
											width: 9,
											height: 9,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									width: 1101,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 23,
									marginLeft: 20,
									marginRight: 20,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 30,
									marginLeft: 20,
									marginRight: 20,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										marginRight: 239,
										gap: 20,
									}}>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 4,
											border: "none",
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 16,
											paddingRight: 16,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"All"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 16,
											paddingRight: 16,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
											}} >
											{"Articles"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 16,
											paddingRight: 16,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
											}} >
											{"Videos"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 16,
											paddingRight: 16,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
											}} >
											{"Templates"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 8,
											paddingBottom: 8,
											paddingLeft: 16,
											paddingRight: 16,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 14,
											}} >
											{"Case Studies & Reports"}
										</span>
									</button>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#FAFAFA",
										borderRadius: 6,
										border: `1px solid #E6E6E6`,
										paddingTop: 9,
										paddingBottom: 9,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 9,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jd8mpfma_expires_30_days.png"} 
										style={{
											width: 16,
											height: 16,
											objectFit: "fill",
										}}
									/>
									<input
										placeholder={"Search resources..."}
										value={input9}
										onChange={(event)=>onChangeInput9(event.target.value)}
										style={{
											color: "#6C6C6C",
											fontSize: 13,
											width: 98,
											background: "none",
											border: "none",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginLeft: 20,
									marginRight: 20,
									gap: 30,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 11,
										border: `1px solid #E6E6E6`,
										paddingTop: 23,
										paddingBottom: 23,
										gap: 17,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 23,
											gap: 18,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ln3vwuct_expires_30_days.png"} 
											style={{
												width: 89,
												height: 89,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 17,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 18,
													fontWeight: "bold",
													width: 121,
												}} >
												{"How to Build a Business Plan"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
												}} >
												{"Type: Article"}
											</span>
										</div>
									</div>
									<button 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #00000000`,
											paddingTop: 12,
											paddingBottom: 12,
											paddingLeft: 76,
											paddingRight: 76,
											marginLeft: 23,
											marginRight: 23,
											gap: 5,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6ka8mzxv_expires_30_days.png"} 
											style={{
												width: 22,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"share with Metee"}
										</span>
									</button>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 11,
										border: `1px solid #E6E6E6`,
										paddingTop: 23,
										paddingBottom: 23,
										gap: 17,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 23,
											gap: 18,
										}}>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												paddingTop: 33,
												paddingBottom: 5,
												gap: 12,
												backgroundImage: 'url(https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/juh4zbfg_expires_30_days.png)',
												backgroundSize: "cover",
												backgroundPosition: "center",
											}}>
											<div 
												style={{
													alignSelf: "stretch",
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/f6rdrxyf_expires_30_days.png"} 
													style={{
														width: 23,
														height: 23,
														objectFit: "fill",
													}}
												/>
											</div>
											<div 
												style={{
													display: "flex",
													alignItems: "center",
													marginLeft: 36,
													gap: 3,
												}}>
												<img
													src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/6ebm68wf_expires_30_days.png"} 
													style={{
														width: 11,
														height: 11,
														objectFit: "fill",
													}}
												/>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 11,
														fontWeight: "bold",
													}} >
													{"12:45"}
												</span>
											</div>
										</div>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 17,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 18,
													fontWeight: "bold",
													width: 144,
												}} >
												{"Market Research Strategies"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
												}} >
												{"Type: Video"}
											</span>
										</div>
									</div>
									<button 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #00000000`,
											paddingTop: 12,
											paddingBottom: 12,
											paddingLeft: 76,
											paddingRight: 76,
											marginLeft: 23,
											marginRight: 23,
											gap: 5,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hsy2t870_expires_30_days.png"} 
											style={{
												width: 22,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"share with Metee"}
										</span>
									</button>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "#FFFFFF",
										borderRadius: 11,
										border: `1px solid #E6E6E6`,
										paddingTop: 23,
										paddingBottom: 23,
										gap: 17,
									}}>
									<div 
										style={{
											display: "flex",
											alignItems: "center",
											marginLeft: 23,
											gap: 18,
										}}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7sge2yzt_expires_30_days.png"} 
											style={{
												width: 89,
												height: 89,
												objectFit: "fill",
											}}
										/>
										<div 
											style={{
												flexShrink: 0,
												display: "flex",
												flexDirection: "column",
												alignItems: "flex-start",
												gap: 17,
											}}>
											<span 
												style={{
													color: "#010101",
													fontSize: 18,
													fontWeight: "bold",
													width: 121,
												}} >
												{"How to Build a Business Plan"}
											</span>
											<span 
												style={{
													color: "#6C6C6C",
													fontSize: 14,
												}} >
												{"Type: Article"}
											</span>
										</div>
									</div>
									<button 
										style={{
											display: "flex",
											alignItems: "center",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #00000000`,
											paddingTop: 12,
											paddingBottom: 12,
											paddingLeft: 76,
											paddingRight: 76,
											marginLeft: 23,
											marginRight: 23,
											gap: 5,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<img
											src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mi4k691m_expires_30_days.png"} 
											style={{
												width: 22,
												height: 22,
												objectFit: "fill",
											}}
										/>
										<span 
											style={{
												color: "#6BD0F6",
												fontSize: 14,
												fontWeight: "bold",
											}} >
											{"share with Metee"}
										</span>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}